module.exports = __webpack_public_path__ + "static/media/book-icon.c2823981.svg";